// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error {\n  color: red;\n  font-size: 15px;\n}\n.flex {\n  display: flex;\n}\n.flex-1 {\n  flex: 1;\n}\n", ""]);
// Exports
module.exports = exports;
